import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ssoLayout from '../views/sso/homePage/sso-layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    redirect: '/homePage',
    children:[{
      path: '/homePage',
      name: 'homePage',
      meta: {title: '首页'},
      component: () => import('../views/homePage/homePage.vue')
    },{
      path: '/personCenter',
      name: 'personCenter',
      redirect: '/myDoneFile',
      meta: {title: '个人中心'},
      component: () => import('../views/personCenterPage/personCenter.vue'),
      children: [{
        path: '/myHome',
        name: 'myHome',
        meta: {title: '我的主页'},
        component: () => import('../views/personCenterPage/myHome.vue'),
      },{
        path: '/myInfo',
        name: 'myInfo',
        meta: {title: '互动消息'},
        component: () => import('../views/personCenterPage/myInfo.vue'),
      },{
        path: '/myMessage',
        name: 'myMessage',
        meta: {title: '我的信息'},
        component: () => import('../views/personCenterPage/myMessage.vue'),
      },{
        path: '/myEvaluate',
        name: 'myEvaluate',
        meta: {title: '我的评价'},
        component: () => import('../views/personCenterPage/myEvaluate.vue'),
      },{
        path: '/myDoneFile',
        name: 'myDoneFile',
        meta: {title: '我的办件'},
        component: () => import('../views/personCenterPage/myDoneFile.vue'),
      },{
        path: '/myHbBuDoneFile',
        name: 'myHbBuDoneFile',
        meta: {title: '政务办件'},
        component: () => import('../views/personCenterPage/myHbBuDoneFile.vue'),
      },{
        path: '/myGovernment',
        name: 'myGovernment',
        meta: {title: '政务服务大数据'},
        component: () => import('../views/personCenterPage/myGovernment.vue'),
      },{
        path: '/myMaterial',
        name: 'myMaterial',
        meta: {title: '我的材料'},
        component: () => import('../views/personCenterPage/myMaterial.vue'),
      },{
        path: '/myCollection',
        name: 'myCollection',
        meta: {title: '我的收藏'},
        component: () => import('../views/personCenterPage/myCollection.vue'),
      },{
        path: '/myFootprint',
        name: 'myFootprint',
        meta: {title: '我的足迹'},
        component: () => import('../views/personCenterPage/myFootprint.vue'),
      }]
    },{
      path: '/cloudClass',
      name: 'cloudClass',
      meta: {title: '楚天行云课堂'},
      component: () => import('../views/homePage/linkPage/cloudClass.vue')
    },{
      path: '/teacherList',
      name: 'teacherList',
      meta: {title: '讲学师资名册'},
      component: () => import('../views/commissionerPage/teacherPage/teacherList.vue')
    },{
      path: '/friendLink',
      name: 'friendLink',
      meta: {title: '友情链接'},
      component: () => import('../views/commissionerPage/friendLinkPage/friendLink.vue')
    },{
      path: '/traningHome',
      name: 'trainingHome',
      redirect: '/traningIntro',
      meta: {title: '点击报名'},
      component: () => import('../views/commissionerPage/trainingPage/home.vue'),
      children: [{
        path: '/traningIntro',
        name: 'traningIntro',
        component: () => import('../views/commissionerPage/trainingPage/traningIntro.vue'),
      },{
        path: '/training',
        name: 'training',
        meta: {title: '全省企事业知识产权专员培训报名'},
        component: () => import('../views/commissionerPage/trainingPage/training.vue')
      },{
        path: '/trainingSuccess',
        name: 'trainingSuccess',
        meta: {title: '全省企事业知识产权专员培训报名'},
        component: () => import('../views/commissionerPage/trainingPage/trainingSuccess.vue')
      }]
    },{
      path: '/patentMarkOperateTrainingHome',
      name: 'patentMarkOperateTrainingHome',
      redirect: '/patentMarkOperateTrainingIntro',
      meta: {title: '数据知识产权登记宣讲暨运营实务培训'},
      component: () => import('../views/commissionerPage/patentMarkOperateTrainingPage/home.vue'),
      children: [{
        path: '/patentMarkOperateTrainingIntro',
        name: 'patentMarkOperateTrainingIntro',
        component: () => import('../views/commissionerPage/patentMarkOperateTrainingPage/traningIntro.vue'),
      },{
        path: '/patentMarkOperateTraining',
        name: 'patentMarkOperateTraining',
        meta: {title: '报名信息'},
        component: () => import('../views/commissionerPage/patentMarkOperateTrainingPage/training.vue')
      },{
        path: '/patentMarkOperateTrainingSuccess',
        name: 'patentMarkOperateTrainingSuccess',
        meta: {title: '报名成功'},
        component: () => import('../views/commissionerPage/patentMarkOperateTrainingPage/trainingSuccess.vue')
      }]
    },{
      path: '/intro',
      name: 'intro',
      meta: {title: '介绍'},
      component: () => import('../views/homePage/intro.vue')
    },{
      path: '/newsList',
      name: 'newsList',
      meta: {title: '我是专员'},
      component: () => import('../views/news/newsList.vue')
    },{
      path: '/newsDetail',
      name: 'newsDetail',
      meta: {title: '新闻详情'},
      component: () => import('../views/news/newsDetail.vue')
    },{
      path: '/infoProject',
      name: 'infoProject',
      meta: {title: '知识产权项目'},
      component: () => import('../views/infoProjectPage/infoProject.vue')
    },{
      path: '/infoQuery',
      name: 'infoQuery',
      meta: {title: '信息快查'},
      component: () => import('../views/infoQueryPage/infoQuery.vue')
    },{
      path: '/transHandle',
      name: 'transHandle',
      meta: {title: '事项快办'},
      component: () => import('../views/transHandlePage/transHandle.vue')
    },{
      path: '/activity',
      name: 'activity',
      meta: {title: '活动参加'},
      component: () => import('../views/activityPage/activity.vue')
    },{
      path: '/wantJoin',
      name: 'wantJoin',
      meta: {title: '我要参加'},
      component: () => import('../views/transHandlePage/wantJoin.vue')
    },{
      path: '/wantBusiness',
      name: 'wantBusiness',
      meta: {title: '我要办事'},
      component: () => import('../views/transHandlePage/wantBusiness.vue')
    },{
      path: '/partIn/:id',
      name: 'partIn',
      meta: {title: '在线申报',requireAuth: true},
      component: () => import('../views/activityPage/partIn.vue')
    },{
      path: '/partInHbBu/:id',
      name: 'partInHbBu',
      meta: {title: '在线申报',requireAuth: true},
      component: () => import('../views/activityPage/partInHbBu.vue')
    },{
      path: '/studentStyle',
      name: 'studentStyle',
      meta: {title: '学员风采'},
      component: () => import('../views/commissionerPage/studentStylePage/studentStyle.vue')
    },{
      path: '/dataFlash',
      name: 'dataFlash',
      meta: {title: '数据快报'},
      component: () => import('../views/dataFlashPage/dataFlash.vue')
    },{
      path: '/serviceResource',
      name: 'serviceResource',
      meta: {title: '机构快访'},
      component: () => import('../views/serviceResourcePage/serviceResource.vue')
    }]
  },{
    path: '/ssoLogin',
    name: 'ssoLogin',
    component: () => import('../views/sso/login/login.vue')
  },{
    path: '/ssoRegister',
    name: 'ssoRegister',
    component: () => import('../views/sso/register/register.vue')
  }
  ,{
    path: '/sso',
    name: 'sso',
    redirect: '/ssoHome',
    component: ssoLayout,
    children:[
      {
        path: '/ssoHome',
        name: 'ssoHome',
        meta: {title: '统一认证首页'},
        component: () => import('../views/sso/homePage/sso-home/sso-home-01.vue')
      },
      {
        path: '/ssoHome1',
        name: 'ssoHome1',
        meta: {title: '统一认证首页1'},
        component: () => import('../views/sso/homePage/sso-home/sso-home.vue')
      },
      {
        path: '/ssoCxnl',
        name: 'ssoCxnl',
        meta: {title: '创新能力查询'},
        component: () => import('../views/sso/cxnlcx/cxnlcx.vue')
      },
      {
        path: '/ssoSxbl',
        name: 'ssoSxbl',
        meta: {title: '事项办理'},
        component: () => import('../views/sso/sxbl/sxbl.vue')
      },
      {
        path: '/ssoDataFusion',
        name: 'ssoDataFusion',
        meta: {title: '数据融合'},
        component: () => import('../views/sso/data-fusion/dataFusion.vue')
      },
      {
        path: '/ssoNewsReport',
        name: 'ssoNewsReport',
        meta: {title: '新闻报告'},
        component: () => import('../views/sso/news-report/newsReport.vue')
      },
      {
        path: '/ssoInfoNotice',
        name: 'ssoInfoNotice',
        meta: {title: '通知公告'},
        component: () => import('../views/sso/infoNotice/infoNotice.vue')
      },
      {
        path: '/ssoStatistic',
        name: 'ssoStatistic',
        meta: {title: '应用监测'},
        component: () => import('../views/sso/applicationWatch/applicationWatch.vue')
      }
    ]
  },{
    path: '/myMap',
    name: 'myMap',
    component: () => import('../views/serviceResourcePage/MyMap.vue')
  },{
    path: '/zxcy',
    name: 'zxcy',
    component: () => import('../views/homePage/zxcy.vue')
  },{
    path: '/rydt',
    name: 'rydt',
    component: () => import('../views/homePage/rydt.vue')
  },{
    path: '/mySearch',
    name: 'mySearch',
    component: () => import('../views/search/mySearch.vue')
  },{
    path: '/bigScreen',
    name: 'bigScreen',
    component: () => import('@/views/bigScreen/components/home.vue'),
    children: [{
      path: '/screenPatent',
      name: 'screenPatent',
      meta: {title: '专利大数据'},
      component: () => import('@/views/bigScreen/components/indexs/index.vue')
    },
    {
      path: '/screenBrand',
      name: 'screenBrand',
      meta: {title: '品牌大数据'},
      component: () => import('@/views/bigScreen/components/indexs/indexBrand.vue')
    }]
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
    var userInfo =  window.localStorage.getItem('userInfo')
    console.log(userInfo)
    if (userInfo) { // 查询本地存储信息是否已经登陆
      next()
    } else { // 跳转统一登录
      window.open(window.SITE_CONFIG['loginURL'],'_self')
    }
  } else {
    next()
  }
})


export default router
